import Config from '@config';
import {
  FiltersGrid,
  Pagination,
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@gasbi/shared/index';
import { OrganizationBankAccount } from '@gasbi/shared/web/RbacOrganization';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

const api = createApi({
  reducerPath: 'organizationBankAccountsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/organization/bank-accounts`,
  }),
  tagTypes: ['OrganizationBankAccounts'],
  endpoints: builder => ({
    getOrganizationBankAccounts: builder.infiniteQuery<
      { items: OrganizationBankAccount[]; total: number },
      FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: '',
        method: 'GET',
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: ['OrganizationBankAccounts'],
    }),
  }),
});

export const organizationBankAccountsApi = api;

const useNormalizedGetOrganizationBankAccountsInfiniteQuery =
  normalizeInfiniteQueryData(
    api.useGetOrganizationBankAccountsInfiniteQuery,
    'items',
  );

export const useGetOrganizationBankAccountsInfiniteQuery = (
  queryArg?: FiltersGrid,
  options?: any,
) => {
  const normalized = useNormalizedGetOrganizationBankAccountsInfiniteQuery(
    queryArg,
    options,
  );
  const { data } = api.useGetOrganizationBankAccountsInfiniteQuery(
    queryArg,
    options,
  );

  return {
    ...normalized,
    total: data?.pages?.[0]?.total ?? normalized.data.length,
  };
};
